/**
 * @description Attribute names used in Tag skeleton DOM elements
 */
export enum TagDomAttribute {
	SMART_TAG_PARENT = 'smart-tag-parent',
	SMART_TAG = 'smart-tag',
	CONTENT = 'smart-tag-content',
	OVERLAY = 'smart-tag-overlay',
	LOADING_ANIMATION = 'smart-tag-loading-animation',
	DIAGNOSTIC = 'smart-tag-diagnostic',
}